import { render, staticRenderFns } from "./RaceSettingsDialog.vue?vue&type=template&id=72587350&scoped=true&"
import script from "./RaceSettingsDialog.vue?vue&type=script&lang=js&"
export * from "./RaceSettingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./RaceSettingsDialog.vue?vue&type=style&index=0&id=72587350&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72587350",
  null
  
)

export default component.exports